<template>
  <div class="card fixe-card-commande">
    <header class="header-card">
      <p> {{ $t('editionCommande.logistiqueImpression.commande.title')}} </p>
    </header>
    <div class="card-content">
      <h1 class="title is-5 has-text-weight-bold has-text-centered is-italic mgb-10px">
        {{ informationsCommande }}
      </h1>
      <v-client-table
        v-if="visuel.length"
        :data="visuel"
        :columns="columns"
        :options="options">
      </v-client-table>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatDate';
import * as tableConfig from '@/configuration/clientTableConf';

export default {
  name: 'CommandeCard',
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visuel: [],
    };
  },
  computed: {
    informationsCommande() {
      const annonceurs = this.commande.intervenants
        .filter((i) => i.annonceur)
        .map((a) => a.nomCommercial);
      return [
        annonceurs.join(', '),
        formatDate(this.commande.datePremierAffichage),
        this.commande.theme,
      ].filter(Boolean).join(' - ');
    },
    columnsData() {
      return [
        { name: 'visuel' },
        { name: 'quantite' },
        { name: 'etat' },
      ];
    },
    columns() {
      const columns = this.columnsData.map((column) => column.name);
      return columns;
    },
    options() {
      const texts = cloneDeep(tableConfig.TEXTS);
      texts.count = '';
      const headings = this.columnsData.reduce((acc, column) => {
        const key = `editionCommande.logistiqueImpression.commande.table.${column.name}`;
        acc[column.name] = this.$te(key) ? this.$t(key) : '';
        return acc;
      }, {});
      return {
        texts,
        headings,
        sortable: [],
        filterable: false,
        sortIcon: tableConfig.SORT_ICON,
        perPageValues: tableConfig.NO_PER_PAGE_VALUE,
        perPage: tableConfig.RESULTS_PER_PAGE,
      };
    },
  },
};

</script>
